export default "__VITE_ASSET__BV0iF$S$__"